import React , { Component } from 'react';
import {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {fetch_firm_info} from '../../actions/footer/createFirmInfoAction';

import FooterSty from './footer.module.css';
import PropTypes from 'prop-types';

import left_logo1 from '../../images/left_logo1.png';
import left_logo2 from '../../images/left_logo2.png';
import firm_qr_code from '../../images/firm_qr_code.png';
import union_qr_dode from '../../images/union_qr_code.png';
import globalStyle from "../../styles/globalStyle";
import {Divider, Space,Row,Col,Carousel} from "antd";
import request from '../../utils/NetWorkUtil';


// const leftLogoData=[
//     {key:0,img:left_logo1,title_p1:'北京经纬通达',title_p2:'管理咨询有限公司'},
//     {key:1,img:left_logo2,title_p1:'中关村石景山园',title_p2:'第一家“中”字头联盟'},
// ];

//友情链接数据
const friendLinksData=[
    {key:0,text:'中华人民共和国科学技术部',url:'http://www.most.gov.cn'},
    {key:1,text:'科学技术部火炬高技术产业开发中心',url:'http://www.chinatorch.gov.cn'},
    {key:2,text:'北京市科学技术委员会',url:'http://kw.beijing.gov.cn'},
    {key:3,text:'国家税务总局',url:'http://www.chinatax.gov.cn'},
    {key:4,text:'中华人民共和国财政部',url:'http://www.mof.gov.cn'},
    {key:5,text:'石景山区科技成果转化应用平台',url:'https://shijingshan.ctex.cn'},
    {key:6,text:'中国技术创业协会',url:'http://www.chinate.org.cn'},
    {key:7,text:'中国留学生创业园联盟',url:'http://www.osechina.com'},
    {key:8,text:'中国铁建股份有限公司',url:'http://www.crcc.cn'},
    {key:9,text:'中国中铁股份有限公司',url:'http://www.crecg.com'},
];

const one=[
    {key:0,text:'中华人民共和国科学技术部',url:'http://www.most.gov.cn'},
    {key:1,text:'科学技术部火炬高技术产业开发中心',url:'http://www.chinatorch.gov.cn'},
    {key:2,text:'北京市科学技术委员会',url:'http://kw.beijing.gov.cn'},
    {key:3,text:'国家税务总局',url:'http://www.chinatax.gov.cn'},
    {key:4,text:'中华人民共和国财政部',url:'http://www.mof.gov.cn'},
    {key:5,text:'石景山区科技成果转化应用平台',url:'https://shijingshan.ctex.cn'},
    {key:6,text:'中国技术创业协会',url:'http://www.chinate.org.cn'},
];

const two=[
    
    {key:7,text:'中国留学生创业园联盟',url:'http://www.osechina.com'},
    {key:8,text:'中国铁建股份有限公司',url:'http://www.crcc.cn'},
    {key:9,text:'中国中铁股份有限公司',url:'http://www.crecg.com'}
];

const groupFriendsLinks=[one,two];

const getFirmInfo=async (method,params)=>{
    return request('/api/Config',{
        method:method,
        params:params,
        headers:{'Content-Type':'application/json'}
    })
}


const Footer =(props)=>{
    const [firm_data,setFirmData]=useState([]);

    useEffect(() => {
        
        (async () => {
            const {data} = await getFirmInfo('get',null);
            // console.log('Footer获取到的data')
            // console.log(data);
            setFirmData(data!=null?data.list:[]);
        })()
        
        
    },[])

    let telephone='';
    let firmAddress='';
    let recordNum='网站备案：';
    let slogan='';
    if(firm_data!=null){
        firm_data.map((item)=>{
            if(item.id==6){
                telephone=item.value;
            }else if(item.id == 10){
                firmAddress=JSON.parse(item.value)['address'];
            }else if(item.id == 11){
                recordNum=recordNum+item.value;
            }
        });
    }

    let leftLogoData=[];
    let rightLogoData=[];
    if(firm_data!=null){
        let title1=firm_data[1]!=undefined?firm_data[1].title:null;
        let img1=firm_data[1]!=undefined?firm_data[1].value:null;
        let obj1={key:0,qr_code_img:img1,title:title1};

        let title2=firm_data[3]!=undefined?firm_data[3].title:null;
        let img2=firm_data[3]!=undefined?firm_data[3].value:null;
        let obj2={key:1,qr_code_img:img2,title:title2};


        rightLogoData.push(obj1);
        rightLogoData.push(obj2);

        let leftLogo1_img=firm_data[0]!=undefined?firm_data[0].value:null;
        let leftLogo2_img=firm_data[2]!=undefined?firm_data[2].value:null;

        obj1={key:0,img:leftLogo1_img,title_p1:'北京经纬通达',title_p2:'管理咨询有限公司'};
        obj2={key:0,img:leftLogo2_img,title_p1:'中国技术创业协会',title_p2:'科技财税服务联盟'}

        leftLogoData.push(obj1);
        leftLogoData.push(obj2);
    }

    

    let leftLogoLis=leftLogoData.map(({key,img,title_p1,title_p2})=>{
        return(
            <div key={key} style={{display: 'flex',flexDirection:'column', justifyContent:'center',alignItems:'center'}}>
                <img src={img} style={{width: 92, height: 75, marginBottom: 12}}/>
                <div>
                    <div style={{display: 'flex',flexDirection:'column', justifyContent:'center',alignItems:'center'}}>{title_p1}</div>
                    <div style={{display: 'flex',flexDirection:'column', justifyContent:'center',alignItems:'center'}}>{title_p2}</div>
                </div>
            </div>
        );
    });

    let rightLogoLis=rightLogoData.map(({key,qr_code_img,title},index)=>{
        // console.log('qrcode_img='+qr_code_img);
        if(qr_code_img!==''){
            return(
                <div key={key} style={{textAlign:'center',letterSpacing:'1px'}}>
                    <img src={qr_code_img} style={{width: 96, height: 96, marginBottom: 12}}/>
                    <div>{title}</div>
                </div>
            );
        }
    });



    let friendLinksLis=groupFriendsLinks.map((item,index)=>{
        let lis=item.map((it,k)=>{
            return( <li style={{width:220,height:20,marginLeft:20}}><a href={it.url} className={FooterSty.friendLinks_a}>{it.text}</a></li> );
        });

        return(
            // 由于使用的那个antd的组件Carousel，所以，想要控制每张幻灯片的整体内样式，要在外面加个div。
            <div>
                <ul style={{...globalStyle.flexAlignItemsEndColumn,width: 1200,height:20}}>
                    {lis} 
                </ul>
            </div>
        );
    });


    return(
        <div style={{...globalStyle.flexCenterRow, background: '#232323', color: '#999999', width: '100%'}}>
            <div style={{display:'flex',flexDirection:'column', justifyContent:'center',alignItems:'center'}}>
                {/* 底部网站信息 */}
                <div style={{...globalStyle.flexSpaceBetweenRow, width: 1200, height: 262}}>
                    <Space size="large">{leftLogoLis}</Space>
                    <Divider type="vertical" style={{height: '70%', background: '#999999'}}/>
                    <div>
                        <div>
                            <div style={{...globalStyle.flexSpaceBetweenRow}}>
                                <div style={{lineHeight: '28px'}}>
                                    <div style={{textAlign: 'left'}}>办公电话:</div>
                                    <div style={{fontSize: 21, fontWeight: 'bolder', color: '#ffffff'}}>{telephone}</div>
                                </div>
                                <div style={{lineHeight: '28px', letterSpacing: 6, fontSize: 16, fontWeight: 700, marginLeft: 230}}>
                                    <div>成/人/达/己</div>
                                    <div>合/作/共/赢</div>
                                </div>
                            </div>
                            <Divider style={{background: '#999999'}}/>
                            <div style={{lineHeight: '28px'}}>
                                <div style={{textAlign: 'left'}}>{firmAddress}</div>
                                <div style={{textAlign: 'left'}}>{recordNum}</div>
                            </div>
                        </div>
                    </div>
                    <Divider type="vertical" style={{height: '70%', background: '#999999'}}/>
                    <Space size="large">{rightLogoLis}</Space>
                </div>

                {/* 友情链接 */}
                <div style={{...globalStyle.flexCenterRow,width:1200,position:'relative',bottom:20}}>
                     <div style={{...globalStyle.flexCenterRow,width: 1200}}>
                        {/* 这个Carousel组件的dotsPosition可以用来控制滑动的方向，在right边就是上下滚动，在bottom边就是左右滚动*/}
                         <Carousel autoplay dots={false} style={{width:1200,height:'20px'}}> 
                                {friendLinksLis}
                         </Carousel>
                     </div>
                     
                </div>
            </div>
        </div>
    );
}

Footer.propTypes={
    className:PropTypes.string,
}


const mapStateToProps=(state)=>{
    return{
       
    }
}


const mapDispatchToProps=(dispatch)=>{
    return {
      
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Footer);
